import { Link } from "react-router-dom"

export default function Footer1() {
	return (
		<>

			<footer className="footer background-black">
				<div className="footer-widgets">
					<div className="themeflat-container">
						<div className="row footer-bottom">
							<div className="col-md-6 col-sm-12">
								<div className="copyright">
									<p>©2023 <Link to="/" target="_blank"></Link> 📞 Azonao atao koa ny miantso mivantana amin’ireto laharana ireto :
										034 41 099 09 / 032 02 006 16.
									</p>
								</div>
							</div>{/* /.col-md-6 */}

						</div>{/* /.row */}
					</div>{/* /.container */}
				</div>{/* /.footer-widgets */}
			</footer>

		</>
	)
}
